// extracted by css-extract-rspack-plugin
module.exports =  {"root":"JobNavigation__root___VSBj7","buttonContainer":"JobNavigation__buttonContainer___Lcjvk"};